(function () {
  
  var container = document.querySelector('.hero__text-align');
  
  if (!container) {
    return;
  }

  var element = document.createElement('div');
  element.setAttribute('class', 'namedays');
  container.appendChild(element);  

  var namedays = {
    '0101': 'Laimnesis / Solvita / Solvija',
    '0102': 'Indulis / Ivo / Iva / Ivis',
    '0103': 'Miervaldis / Miervalda / Ringolds',
    '0104': 'Spodra / Ilva / Ilvita',
    '0105': 'Sīmanis / Zintis',
    '0106': 'Spulga / Arnita',
    '0107': 'Rota / Zigmārs / Juliāns / Digmārs',
    '0108': 'Gatis / Ivanda',
    '0109': 'Kaspars / Aksels / Alta',
    '0110': 'Tatjana / Dorisa',
    '0111': 'Smaida / Franciska',
    '0112': 'Reinis / Reina / Reinholds / Renāts',
    '0113': 'Harijs / Ārijs / Āris / Aira',
    '0114': 'Roberts / Roberta / Raitis / Raits',
    '0115': 'Fēlikss / Felicita',
    '0116': 'Lidija / Lida',
    '0117': 'Tenis / Dravis',
    '0118': 'Antons / Antis / Antonijs',
    '0119': 'Andulis / Alnis',
    '0120': 'Oļģerts / Orests / Aļģirds / Aļģis',
    '0121': 'Agnese / Agnija / Agne',
    '0122': 'Austris',
    '0123': 'Grieta / Strauta / Rebeka',
    '0124': 'Krišs / Ksenija / Eglons / Egle',
    '0125': 'Zigurds / Sigurds / Sigvards',
    '0126': 'Ansis / Agnis / Agneta',
    '0127': 'Ilze / Ildze / Izolde',
    '0128': 'Kārlis / Spodris',
    '0129': 'Aivars / Valērijs',
    '0130': 'Tīna / Valentīna / Pārsla',
    '0131': 'Tekla / Violeta',
    '0201': 'Brigita / Indra / Indars / Indris',
    '0202': 'Spīdola / Sonora',
    '0203': 'Aīda / Ida / Vida',
    '0204': 'Daila / Veronika / Dominiks',
    '0205': 'Agate / Selga / Silga / Sinilga',
    '0206': 'Dace / Dārta / Dora',
    '0207': 'Nelda / Rihards / Ričards / Rišards',
    '0208': 'Aldona / Česlavs',
    '0209': 'Simona / Apolonija',
    '0210': 'Paulīne / Paula / Jasmīna',
    '0211': 'Laima / Laimdota',
    '0212': 'Karlīna / Līna',
    '0213': 'Malda / Melita',
    '0214': 'Valentīns',
    '0215': 'Alvils / Olafs / Aloizs / Olavs',
    '0216': 'Jūlija / Džuljeta',
    '0217': 'Donats / Konstance',
    '0218': 'Kora / Kintija',
    '0219': 'Zane / Zuzanna',
    '0220': 'Vitauts / Smuidra / Smuidris',
    '0221': 'Eleonora / Ariadne',
    '0222': 'Ārija / Rigonda / Adrians / Adriāna / Adrija',
    '0223': 'Haralds / Almants',
    '0224': 'Diāna / Dina / Dins',
    '0225': 'Alma / Annemarija',
    '0226': 'Evelīna / Aurēlija / Mētra',
    '0227': 'Līvija / Līva / Andra',
    '0228': 'Skaidrīte / Justs / Skaidra',
    '0229': '',
    '0301': 'Ivars / Ilgvars',
    '0302': 'Lavīze / Luīze / Laila',
    '0303': 'Tālis / Tālavs / Marts',
    '0304': 'Alise / Auce / Enija',
    '0305': 'Austra / Aurora',
    '0306': 'Vents / Centis / Gotfrīds',
    '0307': 'Ella / Elmīra',
    '0308': 'Dagmāra / Marga / Margita',
    '0309': 'Ēvalds',
    '0310': 'Silvija / Laimrota / Liliāna',
    '0311': 'Konstantīns / Agita',
    '0312': 'Aija / Aiva / Aivis',
    '0313': 'Ernests / Balvis',
    '0314': 'Matilde / Ulrika',
    '0315': 'Amilda / Amalda / Imalda',
    '0316': 'Guntis / Guntars / Guntris',
    '0317': 'Ģertrūde / Gerda',
    '0318': 'Ilona / Adelīna',
    '0319': 'Jāzeps / Juzefa',
    '0320': 'Made / Irbe',
    '0321': 'Una / Unigunde / Dzelme / Benedikts / Benedikta',
    '0322': 'Tamāra / Dziedra / Gabriels / Gabriela',
    '0323': 'Mirdza / Žanete / Žanna',
    '0324': 'Kazimirs / Izidors',
    '0325': 'Māra / Mārīte / Marita / Mare',
    '0326': 'Eiženija / Ženija',
    '0327': 'Gustavs / Gusts / Tālrīts',
    '0328': 'Gunta / Ginta / Gunda',
    '0329': 'Aldonis / Agija',
    '0330': 'Nanija / Ilgmārs',
    '0331': 'Gvido / Atvars',
    '0401': 'Dagnis / Dagne',
    '0402': 'Irmgarde',
    '0403': 'Daira / Dairis / Daiva',
    '0404': 'Valda / Herta / Ārvalda / Ārvalds / Ārvaldis',
    '0405': 'Vija / Vidaga / Aivija',
    '0406': 'Zinta / Vīlips / Filips / Dzinta',
    '0407': 'Zina / Zinaīda / Helmuts',
    '0408': 'Edgars / Danute / Dana / Dans',
    '0409': 'Valērija / Žubīte / Alla',
    '0410': 'Anita / Anitra / Zīle / Annika',
    '0411': 'Hermanis / Vilmārs',
    '0412': 'Jūlijs / Ainis',
    '0413': 'Egils / Egīls / Nauris',
    '0414': 'Strauja / Gudrīte',
    '0415': 'Aelita / Gastons',
    '0416': 'Mintauts / Alfs / Bernadeta',
    '0417': 'Rūdolfs / Viviāna / Rūdis',
    '0418': 'Laura / Jadviga',
    '0419': 'Vēsma / Fanija',
    '0420': 'Mirta / Ziedīte',
    '0421': 'Marģers / Anastasija',
    '0422': 'Armands / Armanda',
    '0423': 'Jurģis / Juris / Georgs',
    '0424': 'Visvaldis / Nameda / Ritvaldis',
    '0425': 'Līksma / Bārbala',
    '0426': 'Alīna / Sandris / Rūsiņš',
    '0427': 'Tāle / Raimonda / Raina / Klementīne',
    '0428': 'Gundega / Terēze',
    '0429': 'Vilnis / Raimonds / Laine',
    '0430': 'Lilija / Liāna',
    '0501': 'Ziedonis',
    '0502': 'Zigmunds / Sigmunds / Zigismunds',
    '0503': 'Gints / Uvis',
    '0504': 'Vizbulīte / Viola / Vijolīte',
    '0505': 'Ģirts / Ģederts',
    '0506': 'Gaidis / Didzis',
    '0507': 'Henriete / Henrijs / Jete / Enriko',
    '0508': 'Staņislavs / Staņislava / Stefānija',
    '0509': 'Klāvs / Einārs / Ervīns',
    '0510': 'Maija / Paija',
    '0511': 'Milda / Karmena / Manfreds',
    '0512': 'Valija / Ināra / Ina / Inārs',
    '0513': 'Irēna / Irīna / Ira / Iraīda',
    '0514': 'Krišjānis / Elfa / Aivita / Elvita',
    '0515': 'Sofija / Taiga / Airita / Arita',
    '0516': 'Edvīns / Edijs',
    '0517': 'Herberts / Dailis / Umberts',
    '0518': 'Inese / Inesis / Ēriks',
    '0519': 'Lita / Sibilla / Teika',
    '0520': 'Venta / Salvis / Selva',
    '0521': 'Ernestīne / Ingmārs / Akvelīna',
    '0522': 'Emīlija. Visu neparasto un kalendāros neierakstīto vārdu diena',
    '0523': 'Leontīne / Leokādija / Lonija / Ligija',
    '0524': 'Ilvija / Marlēna / Ziedone',
    '0525': 'Anšlavs / Junora',
    '0526': 'Edvards / Edvarts / Eduards / Varis',
    '0527': 'Dzidra / Gunita / Loreta / Dzidris',
    '0528': 'Vilis / Vilhelms',
    '0529': 'Maksis / Maksims / Raivis / Raivo',
    '0530': 'Vitolds / Lolita / Letīcija',
    '0531': 'Alīda / Jūsma',
    '0601': 'Biruta / Mairita / Bernedīne',
    '0602': 'Lība / Emma',
    '0603': 'Inta / Ineta / Intra',
    '0604': 'Elfrīda / Sintija / Sindija',
    '0605': 'Igors / Margots / Ingvars',
    '0606': 'Ingrīda / Ardis',
    '0607': 'Gaida / Arnis / Arno',
    '0608': 'Frīdis / Frīda / Mundra',
    '0609': 'Ligita / Gita',
    '0610': 'Malva / Anatols / Anatolijs',
    '0611': 'Ingus / Mairis / Vidvuds',
    '0612': 'Nora / Lenora / Ija',
    '0613': 'Zigfrīds / Ainārs / Uva',
    '0614': 'Tija / Saiva / Sentis / Santis / Saivis',
    '0615': 'Baņuta / Žermēna / Vilija / Vits',
    '0616': 'Justīne / Juta',
    '0617': 'Artūrs / Artis',
    '0618': 'Alberts / Madis',
    '0619': 'Viktors / Nils',
    '0620': 'Rasma / Rasa / Maira',
    '0621': 'Emīls / Egita / Monvīds',
    '0622': 'Ludmila / Laimdots / Laimiņš',
    '0623': 'Līga',
    '0624': 'Jānis',
    '0625': 'Milija / Maiga',
    '0626': 'Ausma / Inguna / Ingūna / Inguns / Ausmis',
    '0627': 'Malvīne / Malvis',
    '0628': 'Viesturs / Kitija / Viestards',
    '0629': 'Pēteris / Pāvils / Pauls / Paulis',
    '0630': 'Tālivaldis / Mareks',
    '0701': 'Imants / Rimants / Ingars / Intars',
    '0702': 'Lauma / Ilvars / Halina',
    '0703': 'Benita / Everita / Verita / Emerita',
    '0704': 'Ulvis / Uldis / Sandis / Sandijs',
    '0705': 'Andžs / Andžejs / Edīte / Esmeralda',
    '0706': 'Anrijs / Arkādijs',
    '0707': 'Alda / Maruta',
    '0708': 'Antra / Adele / Ada',
    '0709': 'Zaiga / Asne / Asna',
    '0710': 'Lija / Olīvija / Olivers / Odrija',
    '0711': 'Leonora / Svens',
    '0712': 'Indriķis / Ints / Namejs',
    '0713': 'Margrieta / Margarita',
    '0714': 'Oskars / Ritvars / Anvars',
    '0715': 'Egons / Egmonts / Egija / Henriks / Heinrihs',
    '0716': 'Hermīne / Estere / Liepa',
    '0717': 'Aleksis / Aleksejs / Alekss',
    '0718': 'Rozālija / Roze',
    '0719': 'Jautrīte / Kamila / Digna / Sāra',
    '0720': 'Ritma / Ramona',
    '0721': 'Meldra / Meldris / Melisa',
    '0722': 'Marija / Marika / Marina',
    '0723': 'Magda / Magone / Mērija / Magdalēna',
    '0724': 'Kristīne / Kristīna / Krista / Kristiāna / Kristiāns',
    '0725': 'Jēkabs / Žaklīna',
    '0726': 'Anna / Ance / Annija',
    '0727': 'Marta / Dita / Dite',
    '0728': 'Cecīlija / Cilda',
    '0729': 'Edmunds / Edžus / Vidmants',
    '0730': 'Valters / Renārs / Regnārs',
    '0731': 'Rūta / Ruta / Angelika / Sigita',
    '0801': 'Albīns / Albīna',
    '0802': 'Normunds / Stefans',
    '0803': 'Augusts',
    '0804': 'Romāns / Romualds / Romualda',
    '0805': 'Osvalds / Arvils',
    '0806': 'Askolds / Aisma',
    '0807': 'Alfrēds / Madars / Fredis',
    '0808': 'Mudīte / Vladislavs / Vladislava',
    '0809': 'Madara / Genoveva / Genovefa',
    '0810': 'Brencis / Audris / Inuta',
    '0811': 'Olga / Zita / Liega / Zigita',
    '0812': 'Vizma / Klāra',
    '0813': 'Elvīra / Velga / Rēzija',
    '0814': 'Zelma / Zemgus / Virma',
    '0815': 'Zenta / Dzelde / Zelda',
    '0816': 'Astra / Astrīda',
    '0817': 'Vineta / Oļegs',
    '0818': 'Liene / Helēna / Elena / Ellena / Liena',
    '0819': 'Melānija / Imanta',
    '0820': 'Bernhards / Boriss / Rojs',
    '0821': 'Janīna / Linda',
    '0822': 'Rudīte / Everts',
    '0823': 'Vitālijs / Ralfs / Valgudis',
    '0824': 'Bērtulis / Boļeslavs',
    '0825': 'Ludvigs / Ludis / Ivonna / Patrīcija / Patriks',
    '0826': 'Natālija / Tālija / Broņislavs / Broņislava',
    '0827': 'Žanis / Jorens / Alens',
    '0828': 'Auguste / Guste',
    '0829': 'Armīns / Vismants / Aiga',
    '0830': 'Alvis / Jolanta / Samanta',
    '0831': 'Vilma / Aigars',
    '0901': 'Ilmārs / Iluta / Austrums',
    '0902': 'Elīza / Lizete / Zete',
    '0903': 'Berta / Bella',
    '0904': 'Dzintra / Dzintara / Dzintars',
    '0905': 'Klaudija / Persijs / Vaida',
    '0906': 'Maigonis / Magnuss / Mariuss',
    '0907': 'Regīna / Ermīns',
    '0908': 'Ilga',
    '0909': 'Bruno / Telma',
    '0910': 'Jausma / Albertīne',
    '0911': 'Signe / Signija',
    '0912': 'Erna / Evita / Eva',
    '0913': 'Iza / Izabella',
    '0914': 'Sanita / Santa / Sanda / Sanija / Sandija',
    '0915': 'Sandra / Gunvaldis / Gunvaris / Sondra',
    '0916': 'Asja / Asnate / Dāgs',
    '0917': 'Vera / Vaira / Vairis',
    '0918': 'Liesma / Elita / Alita',
    '0919': 'Verners / Muntis',
    '0920': 'Guntra / Ginters / Marianna',
    '0921': 'Modris / Matīss / Mariss',
    '0922': 'Māris / Mārica / Maigurs',
    '0923': 'Vanda / Veneranda / Venija',
    '0924': 'Agris / Agrita',
    '0925': 'Rodrigo / Rauls',
    '0926': 'Gundars / Kurts / Knuts',
    '0927': 'Ādolfs / Ilgonis',
    '0928': 'Sergejs / Svetlana / Lana',
    '0929': 'Miķelis / Mikus / Miks / Mihails',
    '0930': 'Elma / Menarda / Elna',
    '1001': 'Zanda / Lāsma / Zandis',
    '1002': 'Ilma / Skaidris',
    '1003': 'Elza / Ilizana',
    '1004': 'Modra / Francis / Dmitrijs',
    '1005': 'Amālija / Amēlija',
    '1006': 'Monika / Zilgma / Zilga',
    '1007': 'Daumants / Druvvaldis',
    '1008': 'Aina / Anete',
    '1009': 'Elga / Helga / Elgars',
    '1010': 'Arvīds / Arvis / Druvis',
    '1011': 'Monta / Tince / Silva',
    '1012': 'Valfrīds / Kira',
    '1013': 'Irma / Mirga',
    '1014': 'Vilhelmīne / Minna',
    '1015': 'Eda / Hedviga / Helvijs',
    '1016': 'Daiga / Dinija / Dinārs',
    '1017': 'Gaits / Karīna / Gaitis',
    '1018': 'Rolands / Rolanda / Ronalds / Erlends / Lūkass',
    '1019': 'Elīna / Drosma / Drosmis',
    '1020': 'Leonīds / Leonīda',
    '1021': 'Urzula / Severīns',
    '1022': 'Īrisa / Irīda / Airisa',
    '1023': 'Daina / Dainis / Dainida',
    '1024': 'Renāte / Modrīte / Mudrīte',
    '1025': 'Beāte / Beatrise',
    '1026': 'Amanda / Kaiva / Amanta',
    '1027': 'Lilita / Irita / Ita',
    '1028': 'Ņina / Ninona / Antoņina / Oksana',
    '1029': 'Laimonis / Elvijs / Elva / Elvis / Laimis',
    '1030': 'Nadīna / Ulla / Adīna',
    '1031': 'Valts / Rinalds / Rinalda',
    '1101': 'Ikars',
    '1102': 'Vivita / Dzīle / Viva',
    '1103': 'Ērika / Dagnija',
    '1104': 'Atis / Otomārs / Oto',
    '1105': 'Šarlote / Lote',
    '1106': 'Linards / Leons / Leo / Leonards / Leonarda',
    '1107': 'Helma / Lotārs',
    '1108': 'Aleksandra / Agra',
    '1109': 'Teodors',
    '1110': 'Mārtiņš / Mārcis / Markuss / Marks',
    '1111': 'Ojārs / Rainers / Nellija',
    '1112': 'Kaija / Kornēlija',
    '1113': 'Eižens / Jevgeņijs / Jevgeņija',
    '1114': 'Fricis / Vikentijs / Vincents',
    '1115': 'Leopolds / Undīne / Unda',
    '1116': 'Banga / Glorija',
    '1117': 'Hugo / Uga / Uģis',
    '1118': 'Aleksandrs / Doloresa / Brīve',
    '1119': 'Elizabete / Liza / Līze / Betija',
    '1120': 'Anda / Andīna / Vigo',
    '1121': 'Zeltīte / Andis',
    '1122': 'Aldis / Alfons / Aldris',
    '1123': 'Zigrīda / Zigfrīda / Zigrīds',
    '1124': 'Velta / Velda',
    '1125': 'Katrīna / Kate / Kadrija / Trīne / Katrīne',
    '1126': 'Konrāds / Sebastians',
    '1127': 'Lauris / Norberts',
    '1128': 'Rita / Vita / Olita',
    '1129': 'Ignats / Virgīnija',
    '1130': 'Andrievs / Andrejs / Andris',
    '1201': 'Arnolds / Emanuels',
    '1202': 'Meta / Sniedze',
    '1203': 'Evija / Raita / Jogita',
    '1204': 'Baiba / Barbara / Barba',
    '1205': 'Sabīne / Sarma / Klaudijs',
    '1206': 'Nikolajs / Niklāvs / Niks / Nikola',
    '1207': 'Antonija / Anta / Dzirkstīte',
    '1208': 'Gunārs / Vladimirs / Gunis',
    '1209': 'Tabita / Sarmīte',
    '1210': 'Guna / Judīte',
    '1211': 'Voldemārs / Valdemārs / Valdis',
    '1212': 'Otīlija / Iveta',
    '1213': 'Lūcija / Veldze',
    '1214': 'Auseklis / Gaisma',
    '1215': 'Johanna / Hanna / Jana',
    '1216': 'Alvīne',
    '1217': 'Hilda / Teiksma',
    '1218': 'Kristaps / Kristofers / Krists / Klinta / Kristers',
    '1219': 'Lelde / Sarmis',
    '1220': 'Arta / Minjona',
    '1221': 'Toms / Tomass / Saulcerīte',
    '1222': 'Saulvedis',
    '1223': 'Viktorija / Balva',
    '1224': 'Ādams / Ieva',
    '1225': 'Stella / Larisa',
    '1226': 'Dainuvīte / Gija / Megija',
    '1227': 'Elmārs / Inita / Helmārs',
    '1228': 'Inga / Ivita / Irvita / Ingeborga',
    '1229': 'Solveiga / Ilgona',
    '1230': 'Dāvids / Dāvis / Dāniels / Daniela / Daniels',
    '1231': 'Silvestrs / Silvis / Kalvis'
  };

  var months = [
    '',
    'janvāris',
    'februāris',
    'marts',
    'aprīlis',
    'maijs',
    'jūnijs',
    'jūlijs',
    'augusts',
    'septembris',
    'oktobris',
    'novembris',
    'decembris'
  ];

  var currentDate = new Date();
  currentDate.setHours(currentDate.getHours() - (currentDate.getTimezoneOffset() / 60));

  var dateString = currentDate.toISOString();
  var day = parseInt(dateString.substr(8, 2));
  var month = parseInt(dateString.substr(5, 2));
  var key = dateString.substr(5, 5).replace('-', '');

  // 13.jūlijs - Margrieta / Margarita / Indriķis
  var text = day + '. ' + months[month] + ' - ' + namedays[key];

  element.textContent = text;

})();
